import {Badge, Button, IconButton, styled} from "@mui/material";

export const FilterIconButton = styled(IconButton)<{
    isActive?: boolean;
}>`
  background-color: ${({isActive}) => isActive ? 'rgba(177, 165, 165, 0.34)' : ''};
  //border: ${({isActive}) => isActive ? '5px solid black' : ''};
  //box-shadow: ${({isActive}) => isActive ? '0px 0px 5px 0px rgba(177, 165, 165, 0.34)' : ''};
`;

export const CustomBadge = styled(Badge)<{ isFilter?: boolean }>`
  .MuiBadge-dot {
    background-color: ${({isFilter}) => (isFilter ? 'red' : '#F57B20')};
  }
`;

export const CheckboxBadge = styled(CustomBadge)`
  .MuiBadge-badge {
    top: 6px;
    right: 5px;
  }
`;

export const Divider = styled('div')`
  width: 100%;
  background-color: #000;
  height: 1px;`;

export const SetDefaultButton = styled(Button)`
  font-size: 14px;
  color: black;
  text-transform: none;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 400;
  padding-top: 0;
  padding-bottom: 0;
`;

export const SetDefaultButtonContainer = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding-left: 4px;
`;
